import React from 'react'
import { Box, Button, FormControl, InputLabel, MenuItem, Select } from '@material-ui/core'
import { AccessAlarm, CheckCircleOutlineOutlined, HighlightOff, StarsRounded } from '@material-ui/icons'
import { dinamicTablesStyles } from './styles'


const HeaderFiltersTable = ({ managers, bosses, selectedActions, handleChange, filterArray }) => {
  // Estados acciones
  // pendiente: 1
  // a tiempo: 2
  // vencida: 3
  // completa : 4
  const classes = dinamicTablesStyles()

  const formatData = (array) => {
    const groupedData = array.reduce((acc, item) => {
      if (!acc[item]) {
        acc[item] = [item];
      } else {
        acc[item].push(item);
      }
      return acc;
    }, {});

    const result = Object.values(groupedData);
    return result
  }
  return (
    <Box className={classes.containerQuizzesFilters}>
      <FormControl>
          <InputLabel id='select-manager' style={{color: '#5A5A5A'}}>Gerente</InputLabel>
          <Select
            labelId='select-manager'
            value={formatData(managers)}
            className={classes.select}
            onChange={e => handleChange(e,'manager')}
          >
            <MenuItem value='todas'>Todos los gerentes</MenuItem>
            {formatData(managers).map((item) => (
              <MenuItem value={item} key={item}>{item}</MenuItem>
            ))}
          </Select>
      </FormControl>
      <FormControl>
          <InputLabel id='select-partner' style={{color: '#5A5A5A'}}>Jefe</InputLabel>
          <Select
            labelId='select-partner'
            value={formatData(bosses)}
            className={classes.select}
            onChange={e => handleChange(e,'boss')}
          >
            <MenuItem value='todas'>Todos los jefes</MenuItem>
            {formatData(bosses).map((item) => (
              <MenuItem value={item} key={item}>{item}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <Box>
          <Button
            className={selectedActions === 'todas' ? classes.btnSelected : classes.btnFilter}
            onClick={() => filterArray('action','todas')}
          >
            Todas las acciones
          </Button>
          <Button
            className={selectedActions === 'totalAcciones' ? classes.btnSelected : classes.btnFilter}
            onClick={() => filterArray('action', 'totalAcciones')}
            startIcon={<StarsRounded style={{ color: '#F5CD26' }} />}
          >
            Total
          </Button>
          <Button
            className={selectedActions === 'totalCompletadas' ? classes.btnSelected : classes.btnFilter}
            onClick={() => filterArray('action','totalCompletadas')}
            startIcon={<CheckCircleOutlineOutlined style={{ color: '#65BA0F' }} />}
          >
            Completas
          </Button>
          <Button
            className={selectedActions === 'totalPendientes' ? classes.btnSelected : classes.btnFilter}
            onClick={() => filterArray('action','totalPendientes')}
            startIcon={<AccessAlarm style={{ color: '#2699FB' }} />}
          >
            Pendientes
          </Button>
          <Button
            className={selectedActions === 'totalVencidas' ? classes.btnSelected : classes.btnFilter}
            onClick={() => filterArray('action','totalVencidas')}
            startIcon={<HighlightOff style={{ color: '#BA330F' }} />}
          >
            Vencidas
          </Button>
      </Box>
    </Box>
  )
}

export default HeaderFiltersTable